import { render, staticRenderFns } from "./MedicationEditAttachements.vue?vue&type=template&id=7705bc1e&scoped=true"
import script from "./MedicationEditAttachements.vue?vue&type=script&lang=js"
export * from "./MedicationEditAttachements.vue?vue&type=script&lang=js"
import style0 from "./MedicationEditAttachements.vue?vue&type=style&index=0&id=7705bc1e&prod&lang=scss"
import style1 from "./MedicationEditAttachements.vue?vue&type=style&index=1&id=7705bc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7705bc1e",
  null
  
)

export default component.exports